"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JurisdictionEvent = void 0;
/**
 * Class description
 *
 * Created: 2019-08-15
 * @author jonas
 */
const GameEvent_1 = require("../event/GameEvent");
class JurisdictionEvent extends GameEvent_1.GameEvent {
}
JurisdictionEvent.MINIMUM_STOP_TIME = "MINIMUM_STOP_TIME";
exports.JurisdictionEvent = JurisdictionEvent;
//# sourceMappingURL=JurisdictionEvent.js.map